export default __webpack_public_path__ + "static/media/foodPic.d289b409.jpg";